<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  class: { type: [String, Object, Array], default: undefined },
});

const emit = defineEmits(["update:modelValue", "change"]);

function toggle() {
  if (props.disabled) return;
  const val = !props.modelValue;
  emit("update:modelValue", val);
  emit("change", val);
}
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="modelValue"
    :disabled="disabled"
    :data-state="modelValue ? 'checked' : 'unchecked'"
    :class="
      cn(
        'peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-border focus-visible:border-foreground focus-visible:ring-foreground/50 dark:data-[state=unchecked]:bg-border/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer',
        props.class
      )
    "
    @click="toggle"
  >
    <span
      :data-state="modelValue ? 'checked' : 'unchecked'"
      class="bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
    />
  </button>
</template>
